/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Go_To_EventInputs */



/**
* | output |
* | --- |
* | "Open the Go To Event window to navigate to a specific event in the selected Event Group" |
*
* @param {Shortcut_Keys_Desc_Go_To_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_go_to_event = /** @type {((inputs?: Shortcut_Keys_Desc_Go_To_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Go_To_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la fenetre Aller a l'evenement pour naviguer vers un evenement specifique dans le groupe selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie das Fenster „Gehe zu Ereignis“, um zu einem bestimmten Ereignis in der ausgewählten Ereignisgruppe zu navigieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aprire la finestra Vai all'evento per passare a un evento specifico nel gruppo di eventi selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте окно «Перейти к событию», чтобы перейти к конкретному событию в выбранной группе событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abra la ventana Ir al evento para navegar a un evento específico en el grupo de eventos seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开“转到事件”窗口，导航至所选事件组中的特定事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントグループ内の特定のイベントに移動するには、「イベントに移動」ウィンドウを開きます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह में किसी विशिष्ट इवेंट पर जाने के लिए गो टू इवेंट विंडो खोलें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra a janela Ir para o Evento para navegar até um evento específico no Grupo de Eventos selecionado.")
	return /** @type {LocalizedString} */ ("Open the Go To Event window to navigate to a specific event in the selected Event Group")
});